import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_refuse_to_bargain_collectively_or_refuse_to_bargai'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_refuse_to_bargain_collectively_or_refuse_to_bargai',
  name: 'Does the facility refuse to bargain collectively or refuse to bargain in good faith with the union, worker representatives, union federations or confederations?',
  description:
    'In the absence of unions, worker representatives, elected and authorized by workers in accordance with national law, should be able to bargain collectively on behalf of workers. However, if a union exists, the employer should not try to undermine it by negotiating directly with elected worker representatives or individual workers on items that are reserved for unions. Negotiations should be carried out in good faith, with both parties negotiating with the expectation and willingness to compromise, discuss and reach a mutually agreed solution. All issues relating to working conditions and terms of employment should be subject to negotiation (the employer should not limit the issues open for negotiation).',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-38',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1156,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
